import { create, tsx } from '@dojo/framework/core/vdom';

import SummaryList from '../../widgets/SummaryList';
import LinkButton from '../../widgets/LinkButton';
import Text from '../../widgets/Text';
import Image from '../../widgets/Image';

import * as css from './SocialCaseStudyList.m.css';

const skRvCompleteMockup = require('../../assets/images/work-mockups/sk-rv-complete-mockup.png');
const skRvCompleteMockupHighRes = require('../../assets/images/work-mockups/sk-rv-complete-mockup@2x.png');
const skRvLifeMockup = require('../../assets/images/work-mockups/sk-rv-life-mockup.png');
const skRvLifeMockupHighRes = require('../../assets/images/work-mockups/sk-rv-life-mockup@2x.png');
const skTripWizardMockup = require('../../assets/images/work-mockups/sk-trip-wizard-mockup-with-shadow.png');
const skTripWizardMockupHighRes = require('../../assets/images/work-mockups/sk-trip-wizard-mockup-with-shadow@2x.png');

export const rvCompleteBlurb =
	'Companies are driven to create efficiencies for repetitious processes. Good solutions prioritize simple configuration and streamlined deployment resulting in less expensive overhead. With plans for onboarding several new partnerships in the near future, Social Knowledge needed a white label mobile application that would embrace these priorities.';
export const rvLifeBlurb =
	'RV Life helps campers simplify their adventures before, during, and after their journeys. The realm of mobile app development is continuously evolving and Social Knowledge needed to accelerate their efforts to refactor their codebase and remove existing obstacles.';
export const tripWizardBlurb =
	'Social Knowledge had a powerful application that was created in a pre-ES2015 world and it was becoming increasingly difficult to efficiently make updates and improvements to its platform. Social Knowledge needed to accelerate their modernization efforts to streamline and modernize their development efforts.';

const socialCaseStudies = {
	complete: {
		title: 'RV Complete',
		blurb: rvCompleteBlurb,
		link: 'casestudySocialRVComplete',
		image: {
			src: skRvCompleteMockup,
			highRes: skRvCompleteMockupHighRes
		}
	},
	trip: {
		title: 'Trip Wizard',
		blurb: tripWizardBlurb,
		link: 'casestudySocialTripWizard',
		image: {
			src: skTripWizardMockup,
			highRes: skTripWizardMockupHighRes
		}
	},
	life: {
		title: 'RV Life',
		blurb: rvLifeBlurb,
		link: 'casestudySocialRVLife',
		image: {
			src: skRvLifeMockup,
			highRes: skRvLifeMockupHighRes
		}
	}
};

interface SocialCaseStudyListProperties {
	caseStudies: (keyof typeof socialCaseStudies)[];
}

const factory = create().properties<SocialCaseStudyListProperties>();

export const SocialCaseStudyList = factory(function SocialCaseStudyList({ properties }) {
	const { caseStudies } = properties();
	return (
		<SummaryList
			style="alternating"
			trailingBias="medium"
			listGuttering="none"
			itemPaddingBottom="md"
		>
			{{
				title: <div classes={[css.title]}>Other Social Knowledge Projects</div>,
				items: caseStudies.map((caseStudy, index) => {
					const {
						blurb,
						link,
						title,
						image: { src, highRes }
					} = socialCaseStudies[caseStudy];
					return {
						blurb: (
							<div
								classes={[
									index !== caseStudies.length - 1 && css.blurbBottomPadding
								]}
							>
								<Text type="body">{blurb}</Text>
								<LinkButton to={link} rel="noindex">
									View Case Study
								</LinkButton>
							</div>
						),
						title,
						image: (
							<div classes={[css.image]}>
								<Image src={src} highResSrc={highRes} lazy />
							</div>
						)
					};
				})
			}}
		</SummaryList>
	);
});

export default SocialCaseStudyList;
